module.exports = {
    language: {
        "5o6u1gm1kjhg": "用户菜单资源",
        "5o6u1gm1k1hg": "用户数据资源",
        "5o6u1gm4k4hs": "请选择要导出的用户",
        "5o6u1gm4k4ha": "超出系统支持范围，请联系系统负责人解决",
        "5o6u1gm4k4ba": "菜单资源",
        "5o6u1gm4kjhg": '空',
        "5o6u1gm4k4hg": '精准查询',
        "5o6u1dm4kjhg": '批量下载',
        "5o1u1gm4kjhg": '批量查询',
        "5o6u1g74kjhg": '跨仓查询',
        "5o6u1gm4k0hg": '个人隐私类',
        "5o6u1ga4kjhg": '个人隐私类（内部）',
        "5o6u1gm4kshg": '商家类',
        "1o6u1gm4kjhg": '财务类',
        "5o6u1gm4kahg": '销售类',
        "5o6u1g84kjhg": '合约类',
        "5o6u1gm4kj4g": '操作风险类',
        "5o6u1gm4kjh1": "公共库",
        "526u1gm4kjhg": "商家工作台库",
        "5o6v4bolg4w2": "京东员工ERP账号",
        "5o6v4bo1g4w1": "京东PIN账号",
        "5o6v4bolg4wm": "供应链产业平台账号",
        "5o6v4bolg4s1": "多租户框架专用账号",
        "5o6v4bowg4w1": "云仓OMS账号",
        "5o6u1gm44xk9": "手机号格式错误", 
        "5o6u1gml4xk9": "关闭所有", 
        "5o6u1gml4ik9": "权限系统", 
        "5o6u1gml4kk9": "切换租户", 
        "5o6usgml4ik9": "选择租户",
        "5o6usgmk4ik9": "注销登录",
        "5o9usgmk4ik9": "常见问题",
        "5o9usgmm4ik9": "帮助文档",
        "5o6v4bolg4w1": "租户编码",
        "5o6v4bokg4w0": "请输入租户编码",
        "5o6v4bovg4w0": "租户名称",
        "5o6v4bolg4q0": "请输入租户名称",
        "5o6v4bolg4qf": "加载中...",
        "5o6v4bolg1q0": "没有更多租户了",
        "5o6v4bolg1l0": "租户已切换至",
        "5o6v4bo2g1l0": "产品使用手册，接口文档",
        "5o6v4bolg190": "今后可以在这里查看啦",
        "5o6v4bolg19a": "批量维护管理权限",
        "5o6v4bolg19s": "导入文件条数最多支持5000条",
        "5o6v4bolg120": "切换新版",
        "5o6v4bolg12s": "该用户已停用！",
        "5o6v4bole12s": "首页",
        "5o6v4bolr12s": "共",
        "5o6u1qna4xqw": "扩展字段",
        "5o6u1qla4xqw": "了解详情",
        "5o6u1qna4jqw": "我知道了",
        "5o6u1qnajxqw": "系统能力升级！",
        "5oju1qns4xqw": "为了满足业务的个性化权限管控需求，目前USF支持业务方基于标准能力进行定制开发，任何符合业务场景的个性化逻辑都可实现定制。诚邀大家的使用！",
        "5o6u1qns4xqj": "目前支持定制开发的场景：",
        "5oju1qvs4xqw": "可配置添加用户时的校验规则；",
        "5o6u1qns4xqh": "可配置用户分配数据资源时的校验规则；",
        "5o6u1qka4qkd": "可自定义权限申请审批结果消息；",
        "5o6u1qkr4qkd": "自定义权限申请审批表单展示内容。",
        "5o6u1qkr4qkq": "更多需求反馈",
        "5o6u1qkr4qkc": "团队",
        "5o6u1qna4xq0": "分配业务系统权限",
        "5o6u1qna4xqk": "分配USF系统权限",
        "5o6u1qna4xqd": "平台管理",
        "5o6u1qka4xqd": "机构管理权限",
        "5o6u1qka4qqd": "条",
        "5o6u1qka4qql": "输入关键字以搜索文档",
        "5o6u1qko4qql": "首页",
        "5o6u1qko41ql": "错误",
        "5o6u1qko4qsl": "退出登录",
        "5o6u1qna4xk0": "请选择角色",
        "5o6u1sna4xk0": "请选择要删除的角色",
        "5o6u1qna9xk0": "该角色已分配给",
        "5o6u1qn44xk0": "位用户，你确定删除该角色？",
        "5o6u1qm44xk0": "确认删除该数据角色？",
        "5o6u1gm44xk0": "请输入活动名称",
        "5o6ukqm44xk0": "请选择活动区域",
        "5o6ukqm44hk0": "类型编码长度不能超过30个字符",
        "5o6ukqm44hb0": "的字段名称最多可输入10个字符",
        "5o6ukqm44hl0": "的字段名称只允许输入数字，字母，下划线，中文",
        "5o6ukqm44hko": "类型编码长度不能超过3的枚举值最多可输入500个字符0个字符",
        "5o6uhqm44hk0": "枚举值尾部不允许有多余的逗号",
        "5o6ukqmi4hk0": "的枚举值需要以: 展示值:Value值这种格式出现，英文冒号和逗号为分隔符，除分隔符外可以输入数字、字母、下划线、中文",
        "5o6uh9m44hk0": "的key或value不能为空",
        "5o6uhqm4yhk0": "不允许重复",
        "5o6uhqm44hl0": "枚举值的key值",
        "5o6uhqm4phl0": "枚举值的value值",
        "5o6uhum4phl0": "我已填好，下一步",
        "5o6uhuk4phl0": "条数据导入失败",
        "5o6umuk4phl0": "删除该角色后，原来已拥有的该角色的用户，可能会失去角色对应的权限",
        "5o6lhuk4phl0": "当前有其他用户正在提交处理中",
        "5o6uhukiphl0": "秒后将自动关闭对话框",
        "5o6uhukiuhl0": "请输入中文、英文、数字、-、_、{、:、/、#、$、}",
        "5o6uhukipfl0": "敏感数据类型",
        "5o6uhukipal0": "软件资源自定义字段",
        "5o6uhukipai0": "菜单名称长度不能超过50个字符",
        "5o6phukipal0": "菜单编码支持中文、英文、数字、-、_、{、:、/、#、$、}",
        "5o6uhupipal0": "菜单编码不超过50个字符",
        "5oouhukipal0": "菜单编码已存在，请重新命名",
        "5oouhukiwal0": "域名长度不能超过400个字符",
        "5oouhubipal0": "域名格式不正确",
        "5oouhuki4al0": "Icon长度不能超过50个字符",
        "5uouhuki4al0": "请输入菜单序号",
        "5oouhuki4au0": "菜单序号已存在，请重新输入",
        "5o6u1qna4po0": "请选择父节点",
        "5o6u1qnalxo0": "该资源已关联菜单角色，变更后未关联角色的父资源将一并关联，是否继续？",
        "5o6u1qnapxk0": "操作成功",
        "5o6u1qna4qk0": "角色",
        "5o6umqnapxk0": "用户组",
        "5o6umqnaqxk0": "用户",
        "5o6umqnapyk0": "分配",
        "5o6umqnaphk0": "点击确定后,删除用户组",
        "5o6umqna9yk0": "用户组编码仅支持中文、英文、数字、-、_、.",
        "5o6uqqna9yk0": "用户组编码长度不能超过80个字符",
        "5o61qqna9yk0": "用户组名称长度不能超过80个字符",
        "5o61qqna8yk0": "分配数据角色",
        "5o61lqna8yk0": "查看数据角色",
        "5o61qqna7yk0": "数据角色",
        "5o61qqnahyk0": "导入用户组",
        "5o61qqnasyk0": "导入用户组菜单角色",
        "5o61qqnalyk0": "导入用户组数据角色",
        "5o617qnalyk0": "暂无数据",
        "5o617qnaly20": "导出详情",
        "5o6s7qnalyk0": "由于本次导出数据量较大，导出结果将于24小时内通过咚咚/邮件下发，请注意查收。",
        "5o6177naly20": "正在导出",
        "5o617mnaly20": "部门",
        "5o617mnply20": "岗位",
        "5o617mnply80": "村/居委会专用",
        "5o617mnply10": "用户类型仅做用户标识，无法为用户分配管理员权限。",
        "5o617mnply11": "请输入密码",
        "5o617mn9ly11": "账号不存在",
        "5o617mu9ly11": "确定授权全部数据权限到选定用户？",
        "5o617mu0ly11": "是否大字段",
        "5o6ukqm14hko": "的枚举值最多可输入200个字符",
        "5o6ukqm14iko": "不允许即是枚举，还是大字段",
        "5o6ukqm14imo": "注：单次导入最多不超过1万条数，超出请分批次上传或选择大批量导入",
        "5o6ukqm1gimo": "重置密码",
        "5o6ukq114imo": "重置手机号",
        "5o6ukql14imo": "重置邮箱",
        "5o6ukqlf4imo": "确认手机号",
        "5o6akql14imo": "请再次输入手机号",
        "5o6akql10imo": "确认邮箱",
        "5oeakql14imo": "请再次输入邮箱",
        "5oeakql14im7": "两次输入手机号不一致",
        "5oeakql14mm7": "两次输入邮箱不一致",
        "5oeakql17mm7": "包含字母、数字、字符中至少两种以上组合,且位数在8-20位之间",
        "5oeakql17mm1": "操作",
        "5orakql17mm1": "用户从以下渠道获得了该数据资源的权限,如果想要去除用户对于该数据资源的权限,需要将用户从以下渠道中全部移除",
        "5oeakql11mm1": "启用后，所选用户将恢复所有权限，确认启用吗？",
        "5oeak2l17mm1": "确认启用",
        "5oeakql17pm1": "停用后，所选用户将失去所有权限，确认停用吗？",
        "5oeakblm7mm1": "停用后，该用户将失去所有权限，无法再登录任何系统",
        "5oeakqlm7mm2": "启用后，该用户将恢复所有权限，并能正常登录使用系统",
        "5oeakqlm7km1": "启用后，该用户将恢复所有权限",
        "5oeakqlm7vm1": "确认停用该用户？",
        "5oeakqlm8mm1": "确认启用该用户？",
        "5oeakqlm7mm1": "确认停用",
        "5oeakqlm7om1": "用户信息",
        "5oeakqlm7om9": "导出失败",
        "5oeakqlmlom9": "导出失败！请重新导出，若仍无结果，请联系USF小妹(org.missusf))",
        "5o6u3wttklw0": "数据资源编码",
        "5o6u3sttkdw0": "分配失败原因",
        "5o6u3wttkgw0": "用户分配数据资源失败",
        "5oku3wttkgw0": "不允许使用换行符",
        "5oku3wttkgl0": "导入机构信息",
        "5oku3wttqgl0": "机构关联岗位",
        "5oku3wttqal0": "机构管理",
        "5oku3wttqal9": "请先选择机构！",
        "5oku3wttqag9": "请至少保留一个显示字段",
        "5oku3wttqsg9": "正在导出，请稍后",
        "5oku3wttqsg5": "中文",
        "5oku3wttqsl9": "英文",
        "5oku3wttqsl1": "请选择语言",
        "5o6u1qna4xo0": "操作前",
        "5o6u1qna53c0": "操作后",
        "5o6u3wttipk0": "应用编码",
        "5o6u3wtti1k0": "如果张三把苹果分配给李四，那么操作人是张三，操作对象是苹果，被操作对象是李四",
        "5o6u3w5ti1k0":"请输入操作人",
        "5o6u3w5ti190": "查看内容",
        "5o6u3w5tm190": "应用管理",
        "5o6l3wttjuo0": "仅显示企业",
        "5o6u3wvtjxs0": "仅显示部门",
        "5o6j3w5tm190":"请输入机构编码",
        "5o6u3wttvb00":"是否有管理权限",
        "5o6u3wttgb00":"销售平台名称",
        "5o6u3wtfvb00":"销售平台主站域名",
        "5o6u3cttvb00":"账号",
        "5o6u3rttvb00":"请输入账号/别名/名称",
        "5o6u3rttbb00":"别名",
        "5o6u3rttvbh0":"仅显示机构",
        "5o6u3rtvvb00":"展开更多",
        "5o6u3rtuvb00":"子节点过多，展示前300，未展示节点请查询！",
        "5o6u3rtuvv00":"机构",
        "5o6u3wttjs00": "请至少选择一项进行设置",
        "5o6u3wttjsv0": "仅能给机构设置超级管理员，不能给部门设置超级管理员，设置超级管理员后，该用户将拥有该机构下所有数据、角色、部门的管理权限。",
        "5o6u3wttjsw0": "操作失败",
        "5o6u3wttjm00": "被操作对象编码",
        "5o6u3wttjrg0": "被操作对象名称",
        "5o6u3wttjuo0": "业务类型",
        "5o6u3wttjxs0": "操作类型",
        "5o6u3wttk1c0": "操作对象编码",
        "5o6u3wttk4o0": "操作对象名称",
        "5o6u3wttk7o0": "操作内容",
        "5o6u3wttkb00": "操作路径",
        "5o6u3wttkdw0": "操作人",
        "5o6u3wttkgk0": "操作时间",
        "5o6u3wttk6k0": "请输入编码",
        "5o6u3wttk3k0": "请选择业务类型",
        "5o6u3ottk6k0": "请选择操作类型",
        "5o6uwcyxcbk0": "敏感标识",
        "5o6uwcyxcls0": "是否可申请不能为空",
        "5o6v3nds2ns0": "统一权限系统(USF)",
        "5o6vnf9ryxc0": "设置成功",
        "5o6vnf9rx200": "应用名称",
        "5o6w90h4lws0": "域名",
        "5o6w90h4mao0": "流程ID",
        "5o6w90h4me80": "应用负责人",
        "5o6w90h4mhc0": "应用负责人erp",
        "5o6w90h4mr80": "请选择需要配置的应用！",
        "5o6w90h4n700": "只能选择一个应用进行配置！",
        "5o6wc500n340": "新增",
        "5o6wc500ng20": "请输入仓库编号",
        "5o6wc500ng30": "新增数据资源",
        "5o6wc500ng40": "请输入仓库名称",
        "5o6wc500ngo0": "长度不能超过30个字符",
        "5o6wbevi5u00": "请输入以data开头的数据资源编码",
        "5o6wazk04rw0": "导入数据资源",
        "5o6wazk04u80": "暂无字段",
        "5o6wazk04x80": "数据资源编码",
        "5o6wazk054w0": "请先选择数据",
        "5o6wazk057c0": "该数据类型未启用任何字段",
        "5o6wak4kg480": "数据资源",
        "5o6wak4kgko0": "导出请求异常,请联系USF运营人员(85257039)",
        "5o6wak4kgog0": "导出按钮请求失败",
        "5o6vkto5xjo0": "确认",
        "5o6vkto5ycw0": "所属系统",
        "5o6vkto5yks0": "请输入英文、数字、_、-",
        "5o6vkto5yvg0": "是否必填字段",
        "5o6vkto5z640": "请用英文逗号隔开",
        "5o6vkto5z8k0": "是否唯一标识",
        "5o6vkto5zb80": "是否显示名称",
        "5o6vkto5zdk0": "请输入类型编码",
        "5o6vkto5zgc0": "类型编码支持英文、数字、-、_",
        "5o6vkto5zkg0": "已存在该类型编码",
        "5o6vkto5zmk0": "请联系管理员",
        "5o6vkto5zow0": "请输入类型名称",
        "5o6vkto5zr40": "类型名称长度不能超过40个字符",
        "5o6vkto5ztc0": "已存在该类型名称",
        "5o6vkto5zv80": "请选择所属系统",
        "5o6vkto5zyw0": "必须有一个必填字段",
        "5o6vkto600s0": "请依次启用扩展字段",
        "5o6vkto602w0": "请填写启用字段的字段名称",
        "5o6vkto604k0": "枚举类型的枚举值不允许为空",
        "5o6vk82zm180": "类型编码",
        "5o6vk82zm540": "类型名称",
        "5o6vk82zmpg0": "请选择要查看的数据！",
        "5o6vk82zmrw0": "只能选择一个数据进行查看！",
        "5o6vh54a0g40": "用户别名",
        "5o6vg67fm240": "审批流ID",
        "5o6vg67fm4k0": "在审批平台配置审批流后即可获取审批ID。",
        "5o6vg67fm740": "查看操作说明",
        "5o6vg67fm9g0": "是否可申请",
        "5o6vg67fmbw0": "角色说明",
        "5o6vg67fmes0": "角色说明将显示在权限申请页面，避免申请人不清楚申请哪些角色",
        "5o6vg67fmm40": "角色名称不能为空",
        "5o6vg67fmog0": "角色名称长度不能超过80个字符",
        "5o6vg67fneo0": "角色编码不能为空",
        "5o6vg67fnms0": "支持字符如下：中文英文数字-_.=+#()（）&",
        "5o6vg67fnqk0": "角色编码长度不能超过80个字符",
        "5o6vg67fntc0": "备注长度不能超过120个字符",
        "5o6vg67foac0": "不能为空",
        "5o6vg67foic0": "资源名称",
        "5o6vg67folw0": "资源编码",
        "5o6vg67foo80": "资源类型",
        "5o6vg67foqc0": "敏感标示",
        "5o6vg67foso0": "该角色已经存在，请重新输入！",
        "5o6veotsluc0": "导出",
        "5o6veotsmas0": "导出菜单角色",
        "5o6veotsmeo0": "导出用户菜单角色",
        "5o6veotsmhk0": "菜单角色名称",
        "5o6veotsmk40": "菜单角色编码",
        "5o6ve68s7yc0": "自定义模块",
        "5o6ve68s8i40": "导入",
        "5o6ve68s8m40": "请至少选择一项进行分配",
        "5o6ve68s8oo0": "只能选择一项进行分配",
        "5o6ve68s8r40": "请至少选择一项进行删除",
        "5o5ve68s8r40": "确定删除选中的",
        "5o5ve68s5r40": "确认删除选中的数据资源吗",
        "5o6ve68h8r40": "吗",
        "5o6ve68s8ts0": "只能选择一项进行删除",
        "5o6ve68s8wg0": "请至少选择一项进行展示",
        "5o6ve68s8ys0": "只能选择一项进行展示",
        "5o6ve68s91g0": "请至少选择一项进行编辑",
        "5o6ve68s93w0": "只能选择一项进行编辑",
        "5o6ve68s9680": "该角色已经分配给用户使用，请先解除关联关系再删除",
        "5o6ve68s98s0": "该角色已经分配给用户/机构使用，请先解除关联关系再删除",
        "5o6ve68s9bg0": "该角色已经分配给用户/用户组使用，请先解除关联关系再删除",
        "5o6ve68s9dw0": "该角色已经分配给用户/用户组/机构使用，请先解除关联关系再删除",
        "5o6ve68s9gc0": "该角色已经分配给机构使用，请先解除关联关系再删除",
        "5o6ve68s9io0": "该角色已经分配给用户组/机构使用，请先解除关联关系再删除",
        "5o6ve68s9lo0": "该角色已经分配给用户组使用，请先解除关联关系再删除",
        "5o6ve68s9o00": "确认删除选中的菜单角色吗",
        "5o6v4bole4o0": "上移",
        "5o6v4bolesg0": "下移",
        "5o6v4bolf5k0": "是否敏感资源",
        "5o6v4bolfsc0": "字段序号",
        "5o6v4bolfv40": "是否启用",
        "5o6v4bolfxo0": "是否必填",
        "5o6v4bolg0c0": "字段名称",
        "5o6v4bolg340": "是否枚举类型",
        "5o6v4bolg5s0": "输入枚举值",
        "5o6v4bolg8s0": "请选择需要删除的数据！",
        "5o6v4bolgcc0": "只能选择一个数据进行删除！",
        "5o6v4bolggs0": "根菜单不可删除！",
        "5o6v4bolgjc0": "请选择需要编辑的数据！",
        "5o6v4bolglk0": "只能选择一个数据进行编辑！",
        "5o6v4bolgnk0": "根菜单不可编辑！",
        "5o6v4bolgpk0": "请选择需要变更的数据！",
        "5o6v4bolgrk0": "只能选择一个数据进行变更！",
        "5o6v4bolgtk0": "根菜单不可变更！",
        "5o6v4bolgvg0": "请选择需要添加的子菜单！",
        "5o6v4bolgxk0": "只能选择一个子菜单编辑！",
        "5o6v4bolgz10": "提示",
        "5o6v4bolgz20": "是否外链",
        "5o6v4bolgz30": "是否自定义报表",
        "5o6v4bolgz40": "高危类别",
        "5o6v4bolgz50": "按钮",
        "5o6v4bolgz60": "其他",
        "5o6v4bolgz70": "请输入菜单编码",
        "5o6v4bolg1w0": "请输入菜单名称",
        "5o6v4bolg2w0": "请选择类型",
        "5o6v4bolg3w0": "请选择是否敏感资源",
        "5o6v4bolg4w0": "菜单序号",
        "5o6v4bolg5w0": "此操作将停用所选菜单, 是否继续?",
        "5o6v4bolg6w0": "查看关联菜单角色",
        "5o6v4bolg7w0": "变更资源父节点",
        "5o6v4bolg8w0": "导出菜单资源",
        "5o6v4bolg9w0": "添加子菜单",
        "5o6v4bol1zw0": "停用菜单",
        "5o6v3o41yxg0": "导入菜单资源",
        "5o6v3o41zg00": "分配给菜单角色",
        "5o6v3o41zjo0": "已分配菜单角色",
        "5o6v3o41zmg0": "变更换父节点",
        "5o6v3o41zp80": "菜单资源管理",
        "5o6v3o41zs80": "添加子资源",
        "5o6v3o41zuw0": "不能删除根资源！",
        "5o6v3o41zxk0": "点击确认后，删除该菜单（及其所有子菜单）",
        "5o6v3o4200g0": "确定删除该菜单吗",
        "5o6v3o420340": "请先选择菜单资源",
        "5o6uyb93u4w0": "用户组关联岗位",
        "5o6uyb93ukc0": "请先选择用户组！",
        "5o6uyb93unw0": "请选择用户组！",
        "5o6uyb93urg0": "添加",
        "5o6uyb93ux80": "查看菜单角色",
        "5o6uyb93v000": "菜单",
        "5o6uyb93v2k0": "数据",
        "5o6uyb93v800": "查看组成员",
        "5o6uyb93vas0": "设置组成员",
        "5o6uyb93vds0": "如果用户组下没有任何成员，没有绑定任何菜单角色或者数据权限，则可以删除用户组",
        "5o6uyb93vg40": "确定删除用户组吗",
        "5o6uyb93vi10": "确定",
        "5o6uyb93vi20": "请输入用户组编码",
        "5o6uyb93vi30": "请输入用户组名称",
        "5o6uyb93vi40": "数据角色编码",
        "5o6uyb93vi50": "数据角色名称",
        "5o6uyb93vi60": "点击确定后,删除用户组 库存水位预警用户组",
        "5o6uut7refw0": "选择导入方式",
        "5o6uut7rf2w0": "下载导入模板",
        "5o6uut7rf780": "上传模板",
        "5o6uut7rfa00": "导入完成",
        "5o6uut7rfck0": "快速导入",
        "5o6uut7rffs0": "导入数量小于1万条",
        "5o6uut7rfio0": "大批量导入",
        "5o6uut7rfl40": "导入数据量1万条以上",
        "5o6uut7rfnw0": "注：单个文件不能超过20M",
        "5o6uut7rfqk0": "选择",
        "5o6uut7rft00": "下载导入模板Excel文件，填写Excel中的字段，保存后上传Excel文件。",
        "5o6uut7rfvs0": "模板填写事项：",
        "5o6uut7rfy00": "将文件拖到此处，或",
        "5o6uut7rg0g0": "点击上传",
        "5o6uut7rg300": "上一步",
        "5o6uut7rg5g0": "等待导入结果",
        "5o6uut7rg7w0": "文件正在导入中，当前导入条数过多，您可以离开界面去处理其他任务，",
        "5o6uut7rgac0": "关闭",
        "5o6uut7rgcs0": "正在解析文件，请稍等......",
        "5o6uut7rgfc0": "导入完成，",
        "5o6uut7rgiw0": "条数据导入成功，",
        "5o6uut7rgl80": "下载导入结果",
        "5o6uut7rgnw0": "重新上传",
        "5o6uut7rgq80": "注：单次文件不能超过20M，超出请分批次上传",
        "5o6uut7rgsc0": "导入完成后结果将通过咚咚/邮件下发，请注意查收。",
        "5o6uut7rguc0": "当前上传文件格式不支持，请按照导入模板上传",
        "5o6uut7rgwc0": "上传文件大小超过10M，请检查文件后重新上传",
        "5o6uut7rgy40": "解析文件失败",
        "5o6uut7rh000": "上传失败",
        "5o6uut7rh110": "1.请按照字段格式要求填写，注意是否必填项；",
        "5o6uut7rh120": "2.字段内容前后不支持：空格、占位符，如包含则文件上传后系统自动过滤；",
        "5o6uut7rh130": "3.若是从其他Excel文件中复制的数据，注意是否将空行一起复制，若存在空行则需要删除，以免导入文件过大上传超时。",
        "5o6uut7rh140": "批量创建用户",
        "5o6uut7rh1s0": "上传文件大小超过20M，请检查文件后重新上传",
        "5o6upp1vnsg0": "权限来源",
        "5o6upp1vom80": "用户从以下渠道获得了该菜单/按钮的权限,如果想要去除用户对于该菜单/按钮的权限,需要将用户从以下渠道中全部移除",
        "5o6upp1vorc0": "权限来源类型",
        "5o6upp1vouc0": "详情",
        "5o6upp1vows0": "查看",
        "5o6upp1vp000": "名称",
        "5o6upp1vp2w0": "编码",
        "5o6upp1vp910": "请求异常",
        "5o6upp1vp920": "用户组编码",
        "5o6upp1vp930": "用户组名称",
        "5o6upp1vp940": "确认删除",
        "5o6upp1vp950": "您确认要删除所选用户吗",
        "5o6upp1vp960": "您确认要删除",
        "5o6upp1vp970": "确认停用该用户",
        "5o6upp1vp980": "停用后，该用户将失去所有权限，无法正常使用系统",
        "5o6upp1vp990": "确认账号解冻",
        "5o6upp1vp9w0": "您确认要解冻账号",
        "5o6up3960fo0": "菜单名称",
        "5o6up3960k80": "菜单编码",
        "5o6umf8wpe40": "数据类型",
        "5o6umf8wq2o0": "请输入",
        "5o6umf8wqfc0": "数据编码",
        "5o6umf8wqi10": "操作提示",
        "5o6umf8wqi20": "仓库编码",
        "5o6umf8wqi00": "仓库名称",
        "5o6uklwd1j00": "添加人",
        "5o6uklwd1mc0": "添加时间",
        "5o6uj7uysb00": "软件系统",
        "5o6uj7uysto0": "角色名称",
        "5o6uj7uysxs0": "角色编码",
        "5o6uj7uyt780": "是否敏感",
        "5o6uj7uyta00": "否",
        "5o6uj7uytcs0": "是",
        "5o6uj7uytfo0": "所属软件系统",
        "5o6uj7uytl10": "所属机构名称",
        "5o6uj7uytlc0": "序号",
        "5o6oshqka0w0": "全部显示",
        "5o6trh9vltc0": "姓名",
        "5o6trh9vmbs0": "请输入关键词",
        "5o6trh9vmg00": "用户账号",
        "5o6trh9vmiw0": "账号别名",
        "5o6trh9vmlw0": "用户状态",
        "5o6trh9vmow0": "启用",
        "5o6trh9vmrs0": "停用",
        "5o6trh9vmuo0": "所属机构",
        "5o6trh9vmxg0": "账号类型",
        "5o6trh9vn080": "创建来源",
        "5o6trh9vn2w0": "创建人",
        "5o6trh9vn600": "查询",
        "5o6trh9vn900": "重置",
        "5o6trh9vnbs0": "展开查询",
        "5o6trh9vnek0": "收起查询",
        "5o6trh9vnh40": "执行了",
        "5o6trh9vnj10": "获取查询参数",
        "5o6trh9vnj20": "口令",
        "5o6trh9vnjs0": "备注2",
        "5o6otz4p17k0": "机构名称",
        "5o6otz4p1bo0": "机构全称",
        "5o6otz4p1eg0": "是否有管理权",
        "5o6otz4p1hc0": "机构编码",
        "5o6otz4p1kc0": "机构负责人",
        "5o6otz4p1n40": "类型",
        "5o6otz4p1ps0": "来源",
        "5o6otz4p1t00": "创建时间",
        "5o6otz4p1w00": "备注",
        "5o6u3frckt00": "查看菜单权限",
        "5o6u3frclb00": "查看数据权限",
        "5o6u3frclj40": "导入用户",
        "5o6u3frclm00": "导入用户菜单角色",
        "5o6u3frclp00": "导入用户数据角色",
        "5o6u3frclrw0": "导入用户数据权限",
        "5o6u3frclus0": "导入用户用户组",
        "5o6u3frcm0s0": "更多",
        "5o6u3frcm3g0": "查看用户数据权限",
        "5o6u3frcm6w0": "查看菜单资源权限",
        "5o6u3frcm9o0": "查看所属用户组",
        "5o6u3frcmco0": "删除",
        "5o6u3frcmfg0": "停用用户",
        "5o6u3frcmi80": "启用用户",
        "5o6u3frcmlc0": "导出用户",
        "5o6u3frcmo40": "账号解冻",
        "5o6u3frcmxc0": "退出批量操作",
        "5o6u3frcncs0": "状态",
        "5o6u3frcno10": "个性化字段",
        "5o6u3frcno20": "添加用户",
        "5o6u3frcno30": "分配菜单角色",
        "5o6u3frcno40": "分配数据资源",
        "5o6u3frcno50": "编辑",
        "5o6u3frcno60": "添加类型",
        "5o6u3frcno70": "密码",
        "5o6u3frcno80": "确认密码",
        "5o6u3frcno90": "手机号",
        "5o6u3frcn1k0": "邮箱",
        "5o6u3frcn3k0": "搜索",
        "5o6u3frcn4k0": "搜索添加",
        "5o6u3frcn5k0": "用户类型",
        "5o6u3frcn6k0": "普通用户",
        "5o6u3frcn7k0": "管理员",
        "5o6u3frcn8k0": "取消",
        "5o6u3frcn9k0": "保存",
        "5o6u3frc1ok0": "请输入用户账号",
        "5o6u3frc2ok0": "用户账号仅支持中文、英文、数字、_、-、.",
        "5o6u3frc3ok0": "用户账号长度不能超过50个字符",
        "5o6u3frc4ok0": "请输入姓名",
        "5o6u3frc5ok0": "姓名长度不能超过80个字符",
        "5o6u3frc6ok0": "包含字母、数字、字符中至少两种以上组合,长度在8-20位",
        "5o6u3frc7ok0": "请再次输入密码",
        "5o6u3frc8ok0": "两次输入密码不一致",
        "5o6u3frc9ok0": "请输入手机号",
        "5o6u3fr2nok0": "请输入邮箱",
        "5o6u3fr3nok0": "邮箱格式错误",
        "5o6u3fr4nok0": "长度应小于 50 个字符",
        "5o6u3fr5nok0": "请选择所属部门",
        "5o6u3fr6nok0": "请选择用户类型",
        "5o6u3fr7nok0": "请选择账号类型",
        "5o6u3fr8nok0": "备注最多120个字符",
        "5o6u3f3cnok0": "请选择",
        "5o6u3f4cnok0": "请填写",
        "5o6u3f5cnok0": "请填写备注",
        "5o6u3f6cnok0": "必填",
        "5o6u3f7cnok0": "新建账号",
        "5o6u3f8cnok0": "添加已有账号",
        "5o6u3f9cnok0": "请输入机构名称",
        "5o6u3frcnok0": "请选择用户！",
        "5o6u3f1cno10": '请先选择机构！'
    }
}
